import { useLayoutEffect, useRef, useState } from 'react';
import { Wrapper, Fade, ExpandButton } from './clamp.styled';
import { ClampProps } from './clamp.types';
import { resolveBackground } from './clamp.utils';

export const Clamp = (props: ClampProps) => {
  const { children, lines = 2, expandLabel = 'Ещё', fadeColor } = props;

  const ref = useRef<HTMLDivElement>(null);

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const [lineHeight, setLineHeight] = useState<number>(20);
  const [resolvedColor, setResolvedColor] = useState<string>('white');

  useLayoutEffect(() => {
    const el = ref.current;

    if (!el) {
      return;
    }

    const lh = parseFloat(getComputedStyle(el).lineHeight);
    const measured = isNaN(lh) ? 20 : lh;

    setLineHeight(measured);
    setIsOverflowing(el.scrollHeight > measured * lines);

    if (!fadeColor) {
      setResolvedColor(resolveBackground(el));
    }
  }, [lines, fadeColor]);

  const handleExpand = () => {
    const el = ref.current;

    if (!el) {
      return;
    }

    setIsAnimating(true);

    const from = el.clientHeight;
    const to = el.scrollHeight;

    el.style.maxHeight = `${from}px`;
    void el.offsetHeight;

    el.style.maxHeight = `${to}px`;

    el.addEventListener(
      'transitionend',
      () => {
        el.style.maxHeight = '';
        setIsExpanded(true);
        setIsAnimating(false);
      },
      { once: true }
    );
  };

  return (
    <Wrapper ref={ref} $collapsed={!isExpanded} $maxHeight={lineHeight * lines}>
      {children}

      {!isExpanded && !isAnimating && isOverflowing && (
        <Fade $height={lineHeight} $resolvedColor={fadeColor ?? resolvedColor}>
          <ExpandButton type="button" onClick={handleExpand}>
            {expandLabel}
          </ExpandButton>
        </Fade>
      )}
    </Wrapper>
  );
};
